import React, { Component } from "react";
import { ButtonToolbar, Table, Grid, Row, Col, FormGroup, ControlLabel, Label } from 'react-bootstrap';
import Select from "react-select";
import { LinkContainer } from 'react-router-bootstrap';

import { PropTypes } from 'prop-types';
import { LoadingSpinner } from "../../LoadingSpinner";
import { TableButton } from '../../TableButton';
import { SortHelper } from "../../helpers/SortHelper";

import ColumnResize from "react-table-column-resizer";

export class PathStopsDraft extends Component {
    constructor(props) {
        super(props);

        this.state = {
            actions: {
                isUpdatingPathstop: false,
                isUpdatingAllPathStops: false,
            },
            updatedPathStopIndex: []
        }
    }

    static contextTypes = {
        edition: PropTypes.object
    }

    renderLabel(value) {
        if (null === value || undefined === value || "" === value) {
            return null;
        }

        return (
            <React.Fragment>
                <Label className="margin-right-5">{value}</Label>
            </React.Fragment>
        );
    }

    renderStopLabel(code, shortName, name) {
        return (
            <div>
                {this.renderLabel(code)}
                {this.renderLabel(shortName)}
                {name}
            </div>
        );
    }

    renderInSpineLabel(inSpine, pathStop, index) {
        if (undefined === inSpine) {
            return "";
        }

        return inSpine ?
            <TableButton onClick={(e) => { e.stopPropagation(); this.updateSpine(pathStop, inSpine, index); }} className="ps-btn-green" icon="icon-ok" /> :
            <TableButton onClick={(e) => { e.stopPropagation(); this.updateSpine(pathStop, inSpine, index); }} className="ps-btn-red" icon="icon-error" />;
    }

    renderComplementaryTerminalLabel(isComplementaryTerminal, pathStop, index, isFirstOrLast) {
        if (isFirstOrLast || !pathStop.inSpine) {
            return "";
        }

        return isComplementaryTerminal ?
            <TableButton onClick={(e) => { e.stopPropagation(); this.updateComplementaryTerminal(pathStop, isComplementaryTerminal, index); }} className="ps-btn-green" icon="icon-ok" /> :
            <TableButton onClick={(e) => { e.stopPropagation(); this.updateComplementaryTerminal(pathStop, isComplementaryTerminal, index); }} className="ps-btn-red" icon="icon-error" />;
    }

    updateComplementaryTerminal(pathStop, isComplementaryTerminal, index) {
        const { actions, updatedPathStopIndex } = this.state;

        actions.isUpdatingPathstop = true;

        this.props.onSavePathStopComplementaryTerminal(pathStop, !isComplementaryTerminal, (a) => this.updateSpineCallback(index));

        this.setState({
            actions: actions,
            updatedPathStopIndex: [
                ...updatedPathStopIndex,
                index
            ]
        });
    }

    updateAllPathStopsSpine(pathStops) {
        const { actions } = this.state;
        const allInSpine = pathStops.every(ps => ps.inSpine === true);

        actions.isUpdatingAllPathStops = true;

        this.setState({
            actions: actions,
        }, () => {
            this.props.onSaveAllPathStopsSpine(pathStops, !allInSpine, () => this.updateAllPathStopsSpineCallback());
        });
    }

    updateAllPathStopsSpineCallback() {
        const { actions } = this.state;

        actions.isUpdatingAllPathStops = false;
        this.setState({
            actions: actions,
        });
    }

    updateSpine(pathStop, inSpine, index) {
        const { actions, updatedPathStopIndex } = this.state;

        actions.isUpdatingPathstop = true;

        this.props.onSavePathStopSpine(pathStop, !inSpine, (a) => this.updateSpineCallback(index));

        this.setState({
            actions: actions,
            updatedPathStopIndex: [
                ...updatedPathStopIndex,
                index
            ]
        });
    }

    updateSpineCallback(index) {
        const { actions, updatedPathStopIndex } = this.state;
        const updatedArray = updatedPathStopIndex.filter((value) => value !== index);

        actions.isUpdatingPathstop = false;

        this.setState({
            actions: actions,
            updatedPathStopIndex: updatedArray,
        });

    }

    renderRegionsLabel(regions) {
        if (!Array.isArray(regions)) {
            return "";
        }

        return regions.map(region => region.name).join(" | ");
    }

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderTable() {
        const { pathSelected } = this.props;
        const { actions, updatedPathStopIndex } = this.state;

        if (undefined === pathSelected) {
            return null;
        }

        const { pathStops, isLoadingPathStops, selectedIds } = this.props;

        const minOrder = pathStops.length > 0 ? Math.min(...pathStops.map(ps => ps.stopOrder)) : null;
        const maxOrder = pathStops.length > 0 ? Math.max(...pathStops.map(ps => ps.stopOrder)) : null;

        return (
            <div className="table-loading">
                <Table responsive striped hover>
                    <thead>
                        <tr className="muted-text">
                            <td>Para selecionar várias paragens, clique nas paragens desejadas e mantenha a tecla Shift pressionada.<br></br>
                                Para mover todas as paragens selecionadas, arraste uma paragem e, ao largar, mantenha a tecla Shift pressionada.</td>
                        </tr>
                        <tr>
                            <th>Paragem</th>
                            <ColumnResize className="columnResizer" />
                            <th>Ordem</th>
                            <ColumnResize className="columnResizer" />
                            <th>Distância</th>
                            <ColumnResize className="columnResizer" />
                            <th>Duração</th>
                            <ColumnResize className="columnResizer" />
                            <th>Regiões</th>
                            <ColumnResize className="columnResizer" />
                            <th>Espinha
                                <TableButton className="ps-btn-select-all" icon="icon-select" title="Selecionar tudo" onClick={() => this.updateAllPathStopsSpine(pathStops)} />
                            </th>
                            <ColumnResize className="columnResizer" />
                            <th>Term. Comp.</th>
                            <ColumnResize className="columnResizer" />
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody className={isLoadingPathStops ? "overlay" : ""} onDrop={(e) => this.props.onDrop(e)}>
                        {
                            pathStops.map((pathStop, idx) =>
                                <tr key={`pathStop-${idx}`}
                                    className={`datamanager selectable${selectedIds.includes(pathStop.id) ? " checked" : ""}`}
                                    draggable={true}
                                    onClick={(e) => this.props.onRowClick(pathStop, idx, e, "draft")}
                                    onDragOver={this.props.onDragOver}
                                    onDragStart={(e) => this.props.onDragStart(e, idx)}>
                                    <td data-value={idx}>{this.renderStopLabel(pathStop.stopCode, pathStop.stopShortName, pathStop.stopName)}</td>
                                    <td className="column_resizer_body" />
                                    <td data-value={idx}>{pathStop.stopOrder}</td>
                                    <td className="column_resizer_body" />
                                    <td data-value={idx}>{pathStop.prevDistance}</td>
                                    <td className="column_resizer_body" />
                                    <td data-value={idx}>{pathStop.duration}</td>
                                    <td data-value={idx}>{this.renderRegionsLabel(pathStop.regions)}</td>
									<td className="column_resizer_body" />
                                    <td data-value={idx}>{this.renderRegionsLabel(pathStop.regions)}</td>
                                    <td className="column_resizer_body" />
                                    <td data-value={idx}>{actions.isUpdatingPathstop && updatedPathStopIndex.some(x => x === idx) ?
                                        <LoadingSpinner
                                            className="psLoading" /> :
                                        this.renderInSpineLabel(pathStop.inSpine, pathStop, idx)} </td>
                                    <td className="column_resizer_body" />
                                    <td data-value={idx}>{actions.isUpdatingPathstop && updatedPathStopIndex.some(x => x === idx) ?
                                        <LoadingSpinner
                                            className="psLoading" /> :
                                        this.renderComplementaryTerminalLabel(pathStop.isComplementaryTerminal, pathStop, idx, pathStop.stopOrder === minOrder || pathStop.stopOrder === maxOrder)}</td>
                                    <td>
                                    <td className="column_resizer_body" />
                                        <ButtonToolbar className="pull-right">
                                            <TableButton marginRight icon="icon-edit" title="Editar" onClick={(e) => { e.stopPropagation(); this.props.onEditClick(pathStop); }} />
                                            <TableButton icon="icon-trash" title="Eliminar" onClick={(e) => { e.stopPropagation(); this.props.onDeleteClick(pathStop); }} />
                                        </ButtonToolbar>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>

                {this.renderLoading(isLoadingPathStops || actions.isUpdatingAllPathStops)}
            </div>
        );
    }

    renderPaths() {
        const { lineSelected } = this.props;

        if (undefined === lineSelected || null === lineSelected) {
            return null;
        }

        const { isLoadingPaths } = this.props;

        if (isLoadingPaths) {
            return <LoadingSpinner />;
        }

        const { paths, pathSelected, isLoadingPathStops } = this.props;

        return (
            <FormGroup controlId="formPath">
                <Row className="row-dropdown">
                    <Col sm={1}>
                        <ControlLabel className="control-label-dropdown">Percurso</ControlLabel>
                    </Col>
                    <Col sm={10}>
                        <Select
                            className="custom-multiselect"
                            placeholder="Selecione um percurso"
                            isDisabled={isLoadingPathStops}
                            noOptionsMessage={() => "Sem Percursos Configurados"}
                            onChange={(e) => this.props.onChangePath(e)}
                            options={paths}
                            isMulti={false}
                            isClearable={true}
                            getOptionValue={value => value.id}
                            getOptionLabel={label => label.code}
                            value={pathSelected}
                        />
                    </Col>
                    <Col sm={1} className="back-buttons">
                        <LinkContainer
                            to={{
                                pathname: "/datamanager/paths",
                                state: { line: lineSelected, dataType: "draft" }
                            }}>
                            <TableButton icon="icon-undo" title="Navegar para percursos" />
                        </LinkContainer>
                    </Col>
                </Row>
            </FormGroup>
        )
    }

    render() {
        const { edition } = this.context;
        const { lines, lineSelected, isLoadingPaths } = this.props;

        return (
            <Grid fluid className="table-small-screens">
                <FormGroup controlId="formLine" className="margin-top-15">
                    <Row className="row-dropdown">
                        <Col sm={1} >
                            <ControlLabel className="control-label-dropdown">Linha</ControlLabel>
                        </Col>
                        <Col sm={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Selecione uma linha"
                                isDisabled={isLoadingPaths}
                                noOptionsMessage={() => "Sem Linhas Configuradas"}
                                onChange={(e) => this.props.onChangeLine(e)}
                                options={lines.sort(SortHelper.defaultLineSorter)}
                                isMulti={false}
                                isClearable={true}
                                getOptionValue={value => value.id}
                                getOptionLabel={label => `${label.code} | ${label.goName} | ««${edition.getDraftNetworkEditionName(label.networkEdition)}»»`}
                                value={lineSelected}
                            />
                        </Col>
                        <Col sm={1} className="back-buttons">
                            <LinkContainer
                                to={{
                                    pathname: "/datamanager/lines",
                                    state: { dataType: "draft" }
                                }}>
                                <TableButton icon="icon-undo" title="Navegar para linhas" />
                            </LinkContainer>
                        </Col>
                    </Row>
                </FormGroup>
                {this.renderPaths()}
                {this.renderTable()}
            </Grid>
        );
    }
}
